// Phase 13.7.5 — Meeting provider detection.
//
// detectMeetingProvider(url) returns the first matching PROVIDER row, or null
// when the URL is empty/unrecognized. Callers render a small chip via
// <ProviderChip provider={detectMeetingProvider(url)} />.

const PROVIDERS = [
  { id: "zoom",       label: "ZOOM",       pattern: /(^|\.)zoom\.us\//i,                                                color: "bg-blue-100 text-blue-800 border-blue-200" },
  { id: "meet",       label: "MEET",       pattern: /(^|\.)meet\.google\.com\//i,                                       color: "bg-green-100 text-green-800 border-green-200" },
  { id: "teams",      label: "TEAMS",      pattern: /(^|\.)teams\.(microsoft|live)\.com\//i,                            color: "bg-purple-100 text-purple-800 border-purple-200" },
  { id: "whereby",    label: "WHEREBY",    pattern: /(^|\.)whereby\.com\//i,                                            color: "bg-orange-100 text-orange-800 border-orange-200" },
  { id: "youtube",    label: "YOUTUBE",    pattern: /(youtube\.com\/(live\/|watch\?|channel\/.*\/live)|youtu\.be\/)/i,  color: "bg-red-100 text-red-800 border-red-200" },
  { id: "linkedin",   label: "LINKEDIN",   pattern: /linkedin\.com\/(events|video\/live)\//i,                           color: "bg-sky-100 text-sky-800 border-sky-200" },
  { id: "streamyard", label: "STREAMYARD", pattern: /streamyard\.com\//i,                                               color: "bg-pink-100 text-pink-800 border-pink-200" },
  { id: "facebook",   label: "FB LIVE",    pattern: /(facebook\.com\/.*\/videos\/|fb\.watch\/)/i,                       color: "bg-blue-100 text-blue-800 border-blue-200" },
  { id: "x",          label: "X SPACE",    pattern: /(twitter|x)\.com\/i\/spaces\//i,                                   color: "bg-gray-100 text-gray-800 border-gray-200" },
];

export function detectMeetingProvider(url) {
  if (!url || typeof url !== "string") return null;
  for (const p of PROVIDERS) if (p.pattern.test(url)) return p;
  return null;
}

export const RECOGNIZED_PROVIDER_LABEL =
  "Zoom, Google Meet, Teams, Whereby, YouTube Live, LinkedIn Live, StreamYard, Facebook Live, and X Spaces";
